import React from "react";
import { Icon } from "rhombus-react";
import { DECISIONING_TYPES, AUTO_OPTIMIZATION_LABELS, DECISIONING_ICON_MAP } from "utils/constants";
import { tellSentry } from "utils/Rave";

export default function Decisioning(props){
	let  { decisioningName }  = props.dependentValues
		,  decisioningType  = props.value
		, icon = DECISIONING_ICON_MAP[decisioningType]
		, { iconName = "", iconClass = "", iconStyle="" } = icon || {}
		;

	if(!decisioningType || decisioningType === DECISIONING_TYPES.NO_DECISIONING){
		return null;
	}

	if(!icon){
		tellSentry(`Unknown Decisioning type: ${props.value}`);
	}

	if(decisioningType === DECISIONING_TYPES.AUTO_OPTIMIZATION){
		// If we have a user friendly label, use it, otherwise just pass through the existing value
		decisioningName = AUTO_OPTIMIZATION_LABELS[decisioningName] || decisioningName;
	}

	return (
		<div className="decisioning-cell">
			<Icon name={iconName} className={iconClass} iconStyle={iconStyle} data-tip={decisioningType} />
			<span title={decisioningName} className="name-overflow">{decisioningName}</span>
		</div>
	);
}
